import React, { TableHTMLAttributes } from 'react';
import { format } from 'date-fns';
import FileSaver from 'file-saver';
import JSZip from 'jszip'
import { getFileFromS3, getFileFromS32 } from '../../Services/s3'
interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  values: Company[],
}

interface DocumentPdf {
  documentUrl?: string;
  documentName?: string;
  bucketFilename?: string;
  id: string;
}
interface TableCompanyProps {
  values: CompanyDocument[],
  onApproveCompany: Function,
  onDeleteCompany: Function,
  onViewDocumentPress: Function,
  onViewModalCompany: Function,
  roles?: string
}

interface CompanyDocument {
  company: Company;
  document: Document[];
  launchType: LaunchType;
}

interface LaunchType {
  name: string;
  description:string;
}

interface Document {
  documentName: string;
  documentUrl: string;
}

interface Company {
  id:string,
  companyName: string,
  createdAt: Date,
  updatedAt: Date,
  cpbAncine: string,
  ancineRegister: string,
  producerName: string,
  enabled: boolean,
  movieTitle: string,
  responsibleProducerName: string,
  phone: string,
  documents: [],
  launchDate: Date,
}


const TableCompany: React.FC<TableCompanyProps>  = ({ values, onApproveCompany, onDeleteCompany, onViewDocumentPress, roles, onViewModalCompany,  ...rest}) =>  {

    const handleGetFileSource = async (bucketFilename: string) => {
      console.log('Trying to get from bucket')
      return await getFileFromS32(bucketFilename, (60 * 5));
    }

  return(
    <table className="table" width="1150px">
      <thead>
      <tr style={{borderBottom:'1', borderWidth:'solid', borderColor:'#f1f1f1'}} >
              <td width={250}  align="left" height="45">
                <b>NOME PRODUTORA</b>
              </td>
              <td width={250}  align="left" height="45">
                <b>NOME DO FILME</b>
              </td>
              <td width={250}  align="left" height="45">
                <b>NOME DO PRODUTOR RESPONSAVEL</b>
              </td>
              <td width={250}  align="left" height="45">
                <b>TELEFONE</b>
              </td>
              <td align="left" height="45">
                <b>REGISTRO ANCINE</b>
              </td>
              <td align="left" height="45">
                <b>CPB ANCINE</b>
              </td>
              <td width="200" align="left" height="45">
                <b>PLATAFORMA</b>
              </td>
              <td width="100" align="center" height="45">
                <b>DATA ESTRÉIA</b>
              </td>
              <td width="100" align="center">
                <b>DATA CADASTRO</b>
              </td>
              <td width="70">
                <b>DOCS</b>
              </td>
              <td width="70">
                <b>DOWNLOAD</b>
              </td>
              <td width="70">
                <b>DETALHES</b>
              </td>
              { roles === 'admin' && <>
              <td width="70">
                <b>APROVAR</b>
              </td>
              <td width="70">
                <b>EXCLUIR</b>
              </td>
              </>}
      </tr>
      </thead>
      <tbody>
        {values?.map((value, _) => {
          return(

            <tr key={_}>
              <td width={100} align="left" height="45">{value.company.producerName}</td>
              <td align="left" height="45">{value.company.movieTitle}</td>
              <td align="left" height="45">{value.company.responsibleProducerName}</td>
              <td align="left" height="45">{value.company.phone}</td>
              <td align="left" height="45">{value.company.ancineRegister}</td>
              <td align="left" height="45">{value.company.cpbAncine}</td>
          <td align="left" height="45">{value.launchType.name}</td>

              <td>{value.company.launchDate ? format(new Date(value.company.launchDate.toString().replace('Z', '')), 'dd/MM/yyyy') :'-/-'}</td>
              <td>{format(new Date(value.company.createdAt), 'dd/MM/yyyy HH:mm')}</td>
              <td>

                <a className="btn btn-info btm-sm" onClick={() => onViewDocumentPress(value.document)
                }>
                  <i className="glyphicon glyphicon-file"></i>
                </a>
              </td>
              <td>
                <a className="btn btn-primary btm-sm" onClick={ async () => {
                  const zip = new JSZip();
                  let total = value.document.length
                  let i = 0
                  //value.document.map(async (file: any) => {
                  for(let i = 0; i < total; i++){
                    let file: any = value.document[i]
                    //zip.file(file.documentName, file.bucketFilename ? handleGetFileSource(file.bucketFilename) : file.documentUrl, { binary: true });
                    //zip.file(file.documentName, "https://kinsta.com/pt/wp-content/uploads/sites/3/2019/08/jpg-vs-jpeg-1024x512.jpg");
                    //zip.file(file.documentName,handleGetFileSource(file.bucketFilename));
                    let urlD = await handleGetFileSource(file.bucketFilename)
                    //const response = await fetch("https://kinsta.com/pt/wp-content/uploads/sites/3/2019/08/jpg-vs-jpeg-1024x512.jpg")
                    const response = await fetch(urlD)
                    const resp = await response.blob();

                    const imgData = new File([resp], file.documentName  );
                    zip.file(file.documentName , imgData, { base64: true });
                    //zip.file(file.documentName + ".png", "img/logo.png");

                  //})
                  }
                  zip.generateAsync({ type: "blob" })
                      .then(function(content) {
                        // see FileSaver.js
                        FileSaver.saveAs(
                          content,
                          value.company.movieTitle + ".zip")
                      });

                  /*FileSaver.saveAs(
                      content,
                      value.company.movieTitle + ".zip"
                    );*/

                } }>
                  <i className="glyphicon glyphicon-download-alt"></i>
                </a>
              </td>
              <td>

                <a className="btn btn-success btm-sm" onClick={() => {

                    onViewModalCompany(value)

                  }}>
                  <i className="glyphicon glyphicon-search"></i>
                </a>
              </td>
              { roles === 'admin' && <>
              <td>
                {
                  value.company.enabled ? 'Aprovado' :
                  <a className="btn btn-success btn-sm" onClick={() => onApproveCompany(value.company.id, _)}>
                    <i className="glyphicon glyphicon-ok"></i>
                  </a>
                }
              </td>
              <td>
                <a className="btn btn-danger btn-sm" onClick={() => onDeleteCompany(value.company.id, _)}>
                  <i className="glyphicon glyphicon-trash"></i>
                </a>
              </td>
              </> }
            </tr>
        )})}
     </tbody>
    </table>
  )
}

export default TableCompany;
